<template>
  <footer class="footer">
    <!-- Logo -->
    <div class="footer-brand">
      <router-link to="/" aria-label="Αρχική CloudTec">
        <img
          :src="require('@/assets/cloudtec-trans.png')"
          alt="CloudTec - Web Apps, Mobile Apps και Digital Solutions"
          class="logo-img"
        />
      </router-link>
    </div>

    <!-- Navigation Links -->
    <div class="footer-links">
      <h3 class="footer-title">Quick Links</h3>
      <ul>
        <li><router-link to="/services/websites">Ιστοσελίδες</router-link></li>
        <li><router-link to="/services/eshops">eShops</router-link></li>
        <li><router-link to="/services/webapps">Web Apps</router-link></li>
        <li><router-link to="/services/mobileapps">Mobile Apps</router-link></li>
        <li><router-link to="/services/dataanalysis">Data Analysis & CRM</router-link></li>
      </ul>
    </div>

    <!-- Social Media Links -->
    <div class="footer-social">
      <h3 class="footer-title">Follow Us</h3>
      <SocialSection />
    </div>

    <!-- Contact Information -->
    <div class="footer-contact">
      <h3 class="footer-title">Επικοινωνία</h3>

      <p>
        <font-awesome-icon icon="mobile-screen-button" style="margin: 2%;" />
        <a class="contact-link" href="tel:+306985786121">+30 698 578 6121</a>
      </p>

      <p>
        <font-awesome-icon icon="envelope" style="margin: 2%;" />
        <a class="contact-link" href="mailto:info@cloudtec.gr">info@cloudtec.gr</a>
      </p>
       <p>
        <font-awesome-icon icon="map-location" style="margin: 2%;" />
        <a class="contact-link" href="mailto:info@cloudtec.gr">Εξυπηρετούμε επιχειρήσεις σε όλη την Ελλάδα.</a>
      </p>
    </div>

    <div class="footer-copyright">
      &copy; {{ currentYear }} Cloudtec.gr. All rights reserved.
    </div>
  </footer>
</template>


<script>
import SocialSection from './SocialSection.vue';

export default {
  name: "FooterMain",
  components: { SocialSection },
  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
  },
};
</script>


<style scoped>
.footer {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  background-color: #0f1922;
  color: #ffffff;
  padding: 2rem 1rem;
  flex-wrap: wrap;
  gap: 2rem;
}

.footer-brand {
  flex: 1;
}

.logo-img {
  width: 50%;
  padding-left: 2rem;
}


.description {
  color: #b0bec5;
  font-size: 0.9rem;
  line-height: 1.6;
  max-width: 200px;
}

.footer-links,
.footer-social,
.footer-contact {
  flex: 1;
  /* min-width: 180px; */
}

.footer-social {
  height: fit-content;
}

.footer-title {
  font-size: 1.1rem;
  font-weight: bold;
  margin-bottom: 1rem;
  color: #ffffff;
}

.footer-links ul {
  list-style: none;
  padding: 0;
}

.footer-links ul li {
  margin-bottom: 0.5rem;
}

.footer-links ul li a {
  color: #b0bec5;
  text-decoration: none;
  transition: color 0.3s ease;
  font-size: 1.2rem;
}

.footer-links ul li a:hover {
  color: #FFC947;
}

.social-icons a {
  margin-right: 0.5rem;
  font-size: 1.5rem;
  color: #64b5f6;
  transition: color 0.3s ease;
}

.social-icons a:hover {
  color: #90caf9;
}

.footer-contact p {
  display: flex;
  align-items: center;
  font-size: 1.2rem;
  color: #b0bec5;
  margin-bottom: 0.5rem;
}

.footer-contact p .fa {
  margin-right: 0.5rem;
}

.footer-copyright {
  width: 100%;
  text-align: center;
  color: #b0bec5;
  font-size: 1rem;
  border-top: 1px solid #3a4a5a;
}


.contact-link {
  color: #b0bec5;
  text-decoration: none;
  transition: color 0.3s ease;
}


/* Responsive layout for smaller screens */
@media (max-width: 768px) {
  .footer {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>